/**
 * _printOrderOptions.js — the choices a print order offers and the words they print as, shared by
 * the order window (frontend/src/components/PrintOrderModal.jsx) and the email
 * (api/print-orders.js), so what the person picks and what the shop reads can't drift.
 * Not routed (leading underscore). See docs/PRINT_ORDERS.md.
 *
 * These lists are the firm's to change: add a size or binding here and both sides pick it up.
 */

export const PRINT_SIZES = [
  { v: 'as_drawn', l: 'Full size (as drawn)' },
  { v: '8.5x11',   l: '8.5" x 11"' },
  { v: '11x17',    l: '11" x 17"' },
  { v: '18x24',    l: '18" x 24"' },
  { v: '24x36',    l: '24" x 36"' },
  { v: '30x42',    l: '30" x 42"' },
  { v: '36x48',    l: '36" x 48"' },
]

export const PRINT_COLORS = [
  { v: 'bw',    l: 'Black and white' },
  { v: 'color', l: 'Color' },
]

export const PRINT_BINDINGS = [
  { v: 'loose',   l: 'Loose sheets' },
  { v: 'stapled', l: 'Stapled' },
  { v: 'bound',   l: 'Bound set (left edge)' },
  { v: 'coil',    l: 'Coil bound' },
  { v: 'folded',  l: 'Folded' },
]

export const PRINT_APPROVALS = [
  { v: 'estimate_first', l: 'Estimate first', d: 'Send us an estimate. Do not print until we approve it.' },
  { v: 'proceed',        l: 'Proceed and bill', d: 'Print now and bill us afterward.' },
]

export const PRINT_DELIVERY = [
  { v: 'pickup',  l: 'Pick up at the shop' },
  { v: 'office',  l: 'Deliver to our office' },
  { v: 'address', l: 'Deliver to an address' },
  { v: 'ship',    l: 'Ship' },
]

export const PRINT_STATUSES = [
  { v: 'sent',              l: 'Sent' },
  { v: 'estimate_received', l: 'Estimate received' },
  { v: 'approved',          l: 'Approved to print' },
  { v: 'complete',          l: 'Complete' },
  { v: 'failed',            l: 'Email failed' },
]

/** The firm's office, for "Deliver to our office". */
export const OFFICE_ADDRESS = 'Alder James Architecture, 31026 Aliso Circle, Laguna Beach, CA 92651'

export function optLabel(list, v) {
  const o = list.find(x => x.v === v)
  return o ? o.l : (v || '')
}

/** One file's print options as a sentence fragment: "24" x 36", Black and white, 3 sets, Bound set (left edge)". */
export function itemSpec(it) {
  const n = Math.max(1, parseInt(it.copies, 10) || 1)
  return [
    optLabel(PRINT_SIZES, it.size),
    optLabel(PRINT_COLORS, it.color),
    n + (n === 1 ? ' copy' : ' copies'),
    optLabel(PRINT_BINDINGS, it.binding),
  ].filter(Boolean).join(', ')
}

/** Where the order goes, as one line. */
export function deliveryLine(method, address) {
  if (method === 'office') return 'Deliver to our office: ' + OFFICE_ADDRESS
  if (method === 'address') return 'Deliver to: ' + (address || '(address to follow)')
  if (method === 'ship') return 'Ship to: ' + (address || '(address to follow)')
  return 'We will pick it up at your shop.'
}
